var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{tag:"component"},_vm._l((_vm.limit),function(i){return (typeof _vm.beads == 'object')?_c('div',{key:i},[_vm._v(_vm._s(_vm.beads[i - 1])+"\n  ")]):_c('div',[_vm._v(_vm._s(_vm.beads)+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }